import { HoneycombWebSDK } from "@honeycombio/opentelemetry-web";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";

const HONEYCOMB_API_KEY = import.meta.env.VITE_HONEYCOMB_API_KEY;
const HONEYCOMB_SERVICE_NAME = import.meta.env.VITE_HONEYCOMB_SERVICE_NAME;

const configDefaults = {
  ignoreNetworkEvents: false,
  // Regex to match your backend URLs. Update to the domains you wish to include.
  propagateTraceHeaderCorsUrls: [/^https:\/\/(dev\.server\.|dev\.)api\.financeable\.com\.au/g],
};

let honeycombSdk: HoneycombWebSDK | null = null;

const initializeObservability = () => {
  // Deployed builds keep observability enabled; local development must opt in explicitly.
  if (import.meta.env.DEV && import.meta.env.VITE_HONEYCOMB_ENABLED !== "true") return;

  // The application can safely call this more than once without registering duplicate instrumentation.
  if (honeycombSdk) return;

  try {
    const sdk = new HoneycombWebSDK({
      debug: import.meta.env.DEV,
      apiKey: HONEYCOMB_API_KEY,
      serviceName: HONEYCOMB_SERVICE_NAME,
      // Keep one in five traces in production. Other environments keep every trace: the server follows this decision,
      // so a sampled-out browser trace also drops the server spans for that request.
      sampleRate: import.meta.env.MODE === "production" ? 5 : 1,
      instrumentations: [
        getWebAutoInstrumentations({
          // Disable Click spans. Preserves Fetch spans, XMLHttpRequest spans, Document and resource-load spans.
          "@opentelemetry/instrumentation-user-interaction": {
            enabled: false,
          },
          // Loads custom configuration for xml-http-request instrumentation.
          "@opentelemetry/instrumentation-xml-http-request": configDefaults,
          "@opentelemetry/instrumentation-fetch": configDefaults,
          "@opentelemetry/instrumentation-document-load": configDefaults,
        }),
      ],
    });

    sdk.start();
    honeycombSdk = sdk;
  } catch {
    // Observability must not prevent the application from starting.
  }
};

export { initializeObservability };
